/** 업로드 검사 코드는 그대로 보존하고 사용자가 취할 행동만 한국어로 설명한다. */
export function inspectionWarningText(code: string): string | null {
  switch (code) {
    case "mask_source_missing":
      return "원본 영상이 없는 mask가 있습니다. 같은 카메라와 파일명의 원본 영상을 확인해 주세요.";
    case "mask_frame_count_mismatch":
      return "mask와 원본 영상의 프레임 수가 다릅니다. Training에서 사용할 파일을 확인해 주세요.";
    case "mask_annotation_camera_missing":
      return "기본 Annotation 번들에 없는 카메라의 mask가 있습니다. 카메라 구성을 확인해 주세요.";
    case "training.annotation_bundle_resolution_unknown":
      return "번들 카메라의 원본 영상 해상도가 미측정이거나 여러 크기로 섞여 있습니다. 영상 검사와 데이터 정리를 마친 뒤 Annotation에서 다시 가져와 주세요.";
    case "training.annotation_bundle_resolution_mismatch":
      return "Annotation PNG 크기가 원본 영상과 다릅니다. 원본 해상도의 PNG와 좌표로 다시 가져와 주세요.";
    case "training.annotation_bundle_too_large":
      return "기본 Annotation 번들의 크기 제한을 넘었습니다. 파일 수 500개, PNG 32 MiB, YAML 1 MiB, 합계 128 MiB 이하로 나누어 가져와 주세요.";
    case "training.annotation_bundle_invalid_path":
    case "training.annotation_bundle_incomplete":
    case "training.annotation_bundle_unknown_camera":
    case "training.annotation_bundle_invalid":
      return "기본 Annotation 번들을 자동 등록하지 못했습니다. PNG/YAML 짝, 카메라 이름과 YAML 내용을 확인한 뒤 Annotation에서 가져와 주세요.";
    default:
      return null;
  }
}
